import "./OurApproach.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Disciplinesintro from "./sections/Disciplinesintro";
import RelatedServicesGrid from "./sections/RelatedServicesGrid";
import Contactcta from "./sections/Contactcta";
import Footer from "@/reusable_sections/Footer";
export default function OurApproachPage() {
  return <div>
      <Header />
      <Intro />
      <Disciplinesintro />
      <RelatedServicesGrid />
      <Contactcta />
      <Footer />
    </div>;
}